import { render } from "./HelloWorld.vue?vue&type=template&id=4231eb0e&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=4231eb0e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4231eb0e"

export default script